export default __webpack_public_path__ + "static/media/cypress.071c7e70.svg";